import sortBy from 'lodash/sortBy';

const _sortBy = sortBy
export default _sortBy;
